import { type InitializationErrorTypes } from '@/constants/basket';

/**
 * An error thrown by our own code that carries copy we intend a diner to read.
 *
 * TEAM-13882 stopped `prepareErrorMessage` from stringifying arbitrary thrown errors into the
 * displayed message, because that is how raw exception text reached diners. But a handful of local
 * `throw new Error(...)` sites relied on exactly that stringification to deliver *deliberate* copy —
 * e.g. TEAM-14699's "A delivery address is required for this order." in `initializeOrderSaga`. Those
 * become `DinerFacingError`, so the copy is intentional and reviewable rather than a side effect of
 * how the funnel happened to build its string.
 *
 * `initializationErrorType` lets a thrower state how the checkout reconciliation modal should treat
 * the failure, instead of that being inferred by substring-matching the message against
 * `INITIALIZATION_ERRORS`.
 */
export class DinerFacingError extends Error {
  readonly dinerMessage: string;
  readonly initializationErrorType?: InitializationErrorTypes;

  constructor(dinerMessage: string, initializationErrorType?: InitializationErrorTypes) {
    super(dinerMessage);
    this.name = 'DinerFacingError';
    this.dinerMessage = dinerMessage;
    this.initializationErrorType = initializationErrorType;
  }
}

export function isDinerFacingError(error: unknown): error is DinerFacingError {
  return error instanceof DinerFacingError;
}
